import AxiosService from "@/Services/AxiosService";
import { Inject, Service } from "vue-di-container";
@Service()
export default class RequestsOverviewService {
  @Inject(AxiosService) public axiosService!: AxiosService;

  public async GetKpis(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-kpis";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data.result;
    } catch (exception) {
      return false;
    }
  }

  public async GetAllRequestsChart(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-all-requests-chart";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetRequestTimeline(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-request-timeline";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetRequestTimelineByCustomerType(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-request-timeline-by-customer-type";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetDelayedRequests(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-delayed-requests";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetAllRequestsDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-all-requests-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetAllRequestsDetailsClients(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-all-requests-details-clients";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportAllRequests(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-all-requests";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetRequestTimelineDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-request-timeline-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetRequestTimelineDetailsClients(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-request-timeline-details-clients";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportRequestTimelineDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-request-timeline-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetTimelineByCustomerTypeDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-timeline-by-customer-type-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetTimelineByCustomerTypeDetailsClients(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-timeline-by-customer-type-details-clients";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportTimelineByCustomerTypeDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-timeline-by-customer-type-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportRequestTimeline(): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-request-timeline";
      const result = await this.axiosService.axiosInstance.post(url, null);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportDelayedRequests(): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-delayed-requests";
      const result = await this.axiosService.axiosInstance.post(url, null);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetDelayedRequestsDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-delayed-requests-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async GetDelayedRequestsDetailsClients(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/get-delayed-requests-details-clients";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }

  public async ExportDelayedRequestsDetails(filter: any): Promise<any> {
    try {
      const url =
        window.$config.HostName +
        "api/monitor-dashboard/requests/overview/export-delayed-requests-details";
      const result = await this.axiosService.axiosInstance.post(url, filter);
      return result.data;
    } catch (exception) {
      return false;
    }
  }
}
